import { Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Socket } from "socket.io-client";
import {
  useGetListNotification,
  useReadNotification,
} from "../../../api/notification";
import { ReactComponent as NodataIcon } from "../../../common/images/svg/Nodata.svg";
import { ButtonTransparent } from "../../../components/button/buttonTransparent";
import { useNotification } from "../../../components/providers/notification/useNotification";
import "./userDetails.css";

const ListAction = [
  { action: "ALL", label: "All" },
  { action: "READ", label: "Read" },
  { action: "UN_READ", label: "Unread" },
];

const start = 0;
const end = 10;

const NotiSetting = ({
  setNotiSetting,
  socket,
  refeatchNoti,
}: {
  setNotiSetting: React.Dispatch<React.SetStateAction<boolean>>;
  socket: Socket<any, any>;
  refeatchNoti: any;
}) => {
  const navigate = useNavigate();
  const { open: openNotification } = useNotification();
  const [action, setAction] = useState(ListAction[0]);
  const [currentPage, setCurrentPage] = useState(1);
  const [params, setParams] = useState<any>({
    start,
    end,
  });

  const handlePageChange = () => {
    setCurrentPage((prev) => {
      const nextPage = prev + 1;
      setParams((prevParams: any) => ({
        ...prevParams,
        end: nextPage * end,
      }));
      return nextPage;
    });
  };

  const { data, refetch, isLoading, isFetching } = useGetListNotification({
    ...params,
    type: action.action,
  });

  const { mutate: readNotification } = useReadNotification({
    onSuccess: () => {
      refetch();
      refeatchNoti();
    },
    onError: (error: { message: string }) => {
      if (openNotification) {
        openNotification({
          key: "read_notification",
          message: "Something went wrong!",
          type: "error",
        });
      }
    },
  });

  const handleReadNotification = (item: any) => {
    if (!item?.read) {
      const body = { id: item?.id };
      readNotification(body);
    }
    navigate(
      `/home?type=${item?.content?.currencyType}&currency=${item?.content?.currencyId}&transactionId=${item?.content?.transactionId}&isNotification=true`
    );
    setNotiSetting(false);
  };

  useEffect(() => {
    const handleNotificationUpdated = () => {
      refetch();
    };
    socket.on(`user.notifications.created`, handleNotificationUpdated);

    return () => {
      socket.off(`user.notifications.created`, handleNotificationUpdated);
    };
  }, [socket, refetch]);

  return (
    <div className="noti-setting">
      <div style={{ padding: "0 16px" }}>
        <Typography
          style={{
            fontSize: "20px",
            fontWeight: 700,
            color: "white",
            lineHeight: "30px",
          }}
        >
          Notification
        </Typography>
      </div>
      <div
        style={{
          padding: "0 16px",
          display: "flex",
          flexDirection: "row",
          gap: 12,
        }}
      >
        {ListAction.map((item) => (
          <div
            key={item.action}
            className={`action ${action?.action === item?.action ? "action-active" : undefined
              }`}
            onClick={() => {
              setAction(item);
              setParams({ start: 0, end: 10 });
            }}
          >
            {item.label}
          </div>
        ))}
      </div>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "550px",
          }}
        >
          <Spin size={"large"} className="custom-spin" />
        </div>
      ) : (
        <>
          {data?.data?.data?.items.length ? (
            <div className="noti-list" onClick={(e) => e.stopPropagation()}>
              {data?.data?.data?.items.map((item: any) => (
                <div
                  key={item?.id}
                  className={`noti-item`}
                  onClick={() => handleReadNotification(item)}
                >
                  <Typography className="noti-item-title">
                    {item?.content?.title}
                  </Typography>
                  <Typography className="noti-item-description">
                    {item?.content?.message}
                  </Typography>
                  {item?.read ? null : <div className="unread-dot"></div>}
                </div>
              ))}
              {data?.data?.data?.page < data?.data?.data?.totalPages ? (
                <>
                  {isFetching ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        minHeight: "32px",
                      }}
                    >
                      <Spin size={"default"} className="custom-spin" />
                    </div>
                  ) : (
                    <ButtonTransparent
                      size={"small"}
                      text={"Load More"}
                      width={"100%"}
                      textClassName="text-button-back"
                      onClick={handlePageChange}
                    />
                  )}
                </>
              ) : null}
            </div>
          ) : (
            <div
              style={{
                padding: "0 16px",
                display: "flex",
                flexDirection: "row",
                width: "100%",
                height: "550px",
              }}
            >
              <div className="empty-transaction">
                <div className="ant-empty-image">
                  <NodataIcon />
                </div>
                <div
                  className="ant-empty-description"
                  style={{ color: "white" }}
                >
                  No data
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default NotiSetting;
